import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["preceptorSelect", "ratingDate", "skillSelect"];

  confirmRemove(event) {
    if (event.submitter && event.submitter.value === "preview") {
      return;
    }

    const preceptorLabel =
      this.preceptorSelectTarget.options[this.preceptorSelectTarget.selectedIndex]
        ?.text || "the selected rater";
    const date = this.ratingDateTarget.value;
    const skillLabel =
      this.skillSelectTarget.options[this.skillSelectTarget.selectedIndex]
        ?.text || "the selected skill";

    const message =
      `Remove all skill ratings and linked competency checks on this event for ` +
      `${preceptorLabel} on ${date} (${skillLabel})? This cannot be undone.`;

    if (!window.confirm(message)) {
      event.preventDefault();
    }
  }
}
